<!--
 * @Description: 新增商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2022-09-22 10:02:58
 * @LastEditors: mdb
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm
        ref="businessFormRef"
        title="新增商机"
        type="add"
        v-model:value="dataForm"
        :saleChanceRefId="saleChanceRefId"
        :arkCodeId="arkCodeId"
        :isFromPotentialCustomer="isFromPotentialCustomer"
        @update:value="fetch"
        @planSaleAmount="planSaleAmount"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">取消</a-button>
      <a-button :loading="loading" @click="handleReset()">重置</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit()">保存</a-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit } from '@/api/gucangSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const route = useRoute()

const dataForm = reactive<FbuBusinessEditParams>({})

// 赋值url参数到dataForm
const saleChanceRefId = ref<boolean>()
const lastPlanSaleAmount = ref<number>()
const arkCodeId = ref<boolean>()
const isFromPotentialCustomer = ref<boolean>() // 是否线索转潜客
if (route.query.saleChanceRefId) {
  dataForm.saleChanceRefId = route.query.saleChanceRefId as string
  saleChanceRefId.value = true
}
if (route.query.arkCodeId) {
  dataForm.arkCodeId = parseInt(route.query.arkCodeId as string)
  arkCodeId.value = true
}
if (route.query.isFromPotentialCustomer) {
  dataForm.isFromPotentialCustomer = true
  isFromPotentialCustomer.value = true
}

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}
const planSaleAmount = (val: any) => {
  lastPlanSaleAmount.value = val
}
const businessFormRef = ref()
const handleReset = () => {
  businessFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    const last = lastPlanSaleAmount.value
    if (last) {
      if (dataForm.planSaleAmount && dataForm.planSaleAmount <= last) {
        message.error('【预计月销售额】需高于上次完结状态的相同商机的预计月销售额')
        return
      }
    }
    loading.value = true
    const params = toRaw(dataForm)
    businessCreateOrEdit(params)
      .then(() => {
        message.success(isFromPotentialCustomer.value ? '转潜客成功' : '新增成功')
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  }).catch((error: any) => {
    console.log(error)
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuBusinessAdd' }
</script>

<style scoped></style>
